import { Page, Document,Text } from '@react-pdf/renderer';
import OrderPrintContent, { styles as printStyles } from './OrderPrintContent'; // Import content and its styles

const OrderPrintDocument = ({ orderData }) => (
  <Document title={`Order - ${orderData?.orderReferance || 'N/A'}`}> {/* Added N/A fallback for title */}
    <Page size="A4" style={printStyles.page} wrap render={({ pageNumber, totalPages }) => (
      <>
        <OrderPrintContent orderData={orderData} pageNumber={pageNumber} totalPages={totalPages} />
      </>
    )} />
  </Document>
);

export default OrderPrintDocument;